import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, Input, ViewChild, OnDestroy } from '@angular/core';

@Component({
    selector: 'tidy-loader',
    template: `
    <div @inOutAnimation>
      <svg width="150" height="100" viewBox="0 0 150 100">
        <circle #cLeft cx="50" cy="50" r="6" />
        <circle #cCenter cx="70" cy="50" r="6" />
        <circle #cRight cx="90" cy="50" r="6" />
      </svg>
    </div>
  `,
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('100ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms', style({ opacity: 0 }))
            ])
        ])
    ],
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('cLeft', {static: false}) cLeft: ElementRef;
  @ViewChild('cCenter', {static: false}) cCenter: ElementRef;
  @ViewChild('cRight', {static: false}) cRight: ElementRef;

  constructor() { }
  animationId: number;

  ngAfterViewInit() {
    const cLeft = this.cLeft.nativeElement,
    cCenter = this.cCenter.nativeElement,
    cRight = this.cRight.nativeElement;

    const centreY = 50;
    const amplitude = 20;
    const speed = 0.009;
    let startTime: number | null = null;

    const animateCircles = (timestamp: number) => {
      if (startTime === null) {
        startTime = timestamp;
      }
      const elapsed = timestamp - startTime;
      const currentAnimationTime = elapsed * speed;
      cLeft.setAttribute('cy', `${centreY + (amplitude * (Math.sin(currentAnimationTime)))}`);
      cCenter.setAttribute('cy', `${centreY + (amplitude * (Math.sin(currentAnimationTime - 1)))}`);
      cRight.setAttribute('cy', `${centreY + (amplitude * (Math.sin(currentAnimationTime - 2)))}`);
      this.animationId = requestAnimationFrame(animateCircles);
    }

    this.animationId = requestAnimationFrame(animateCircles);
  }

  ngOnDestroy() {
    cancelAnimationFrame(this.animationId);
  }
}
